import { gql } from '@apollo/client';

export const NSC_PROGRESSION_DATA = gql`
  fragment nscProgressionData on NSCProgressionData {
    createdAt
    updatedAt
    id
    class
    dateAccessed
    dateCreated
    dataSource
    dateSchoolSubmitted
    emisNumber
    numberAchieved
    numberAchievedProgressed
    numberBachelors
    numberDiploma
    numberEnrolled
    numberHigherCertificate
    numberNSCFail
    numberNSCPass
    numberProgressed
    numberWrote
    numberWroteProgressed
    percentageAchieved
    percentageBachelors
    percentageDiploma
    percentageHigherCertificate
    percentageNSCFail
    percentageNSCPass
    term
    year
    circuit {
      id
      name
    }
    cluster {
      id
      name
    }
    district {
      id
      name
    }
    grade {
      id
      value
    }
    institution {
      id
      emisNumber
      name
    }
    promotionStatus {
      id
      name
    }
    province {
      id
      name
    }
    region {
      id
      name
    }
  }
`;
